module.exports = __webpack_public_path__ + "img/topup_off.e16c5ddf.svg";